var exports = {
  "S": "DataMarqueeSection__dogvyq",
};

module.exports = exports;
